import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'

const Link = ({
  to,
  className,
  target,
  children,
  onClick,
  download,
  ...attributes
}) => {
  // This assumes internal links will start with exactly one slash,
  // and that anything else is external.
  const internal = to ? /^\/(?!\/)/.test(to) : false
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        className={className}
        onClick={onClick}
        {...attributes}
      >
        {children}
      </GatsbyLink>
    )
  }

  if (to) {
    // check if extenal link
    let relOutput = ''
    let targetOutput = ''
    if (target === '_blank') {
      targetOutput = '_blank'
      relOutput = 'noopener noreferrer'
    }

    return (
      <a
        href={to}
        className={className}
        target={targetOutput}
        rel={relOutput}
        download={download}
        {...attributes}
      >
        {children}
      </a>
    )
  }

  if (onClick) {
    const handleKeyDown = e => {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
        e.preventDefault()
        onClick(e)
      }
    }

    return (
      <span
        role="button"
        className={className}
        tabIndex="0"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        {...attributes}
      >
        {children}
      </span>
    )
  }

  return (
    <span className={className} {...attributes}>
      {children}
    </span>
  )
}

Link.defaultProps = {
  to: '',
  target: '',
  className: '',
  onClick: undefined,
  download: false,
}

Link.propTypes = {
  to: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  download: PropTypes.bool,
}

export default Link
